import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieNotice from './components/CookieNotice';
import CampaignPopup from './components/CampaignPopup';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Location from './pages/Location';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Arbetshjalpmedel from './pages/Arbetshjalpmedel';
import Horseltest from './pages/Horseltest';
import Horselskydd from './pages/Horselskydd';
import Horapparater from './pages/Horapparater';
import Service from './pages/Service';
import './i18n/config';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/location" element={<Location />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/arbetshjalpmedel" element={<Arbetshjalpmedel />} />
            <Route path="/horseltest" element={<Horseltest />} />
            <Route path="/horselskydd" element={<Horselskydd />} />
            <Route path="/horapparater" element={<Horapparater />} />
            <Route path="/service" element={<Service />} />
          </Routes>
        </main>
        <Footer />
        <CookieNotice />
        <CampaignPopup />
      </div>
    </Router>
  );
}

export default App;
